/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvoiceContactInfoSnapshot
 */
export interface InvoiceContactInfoSnapshot {
    /**
     * 
     * @type {string}
     * @memberof InvoiceContactInfoSnapshot
     */
    email: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceContactInfoSnapshot
     */
    phoneNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceContactInfoSnapshot
     */
    homePhone: string | null;
}

/**
 * Check if a given object implements the InvoiceContactInfoSnapshot interface.
 */
export function instanceOfInvoiceContactInfoSnapshot(value: object): value is InvoiceContactInfoSnapshot {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    if (!('homePhone' in value) || value['homePhone'] === undefined) return false;
    return true;
}

export function InvoiceContactInfoSnapshotFromJSON(json: any): InvoiceContactInfoSnapshot {
    return InvoiceContactInfoSnapshotFromJSONTyped(json, false);
}

export function InvoiceContactInfoSnapshotFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceContactInfoSnapshot {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'phoneNumber': json['phoneNumber'],
        'homePhone': json['homePhone'],
    };
}

export function InvoiceContactInfoSnapshotToJSON(json: any): InvoiceContactInfoSnapshot {
    return InvoiceContactInfoSnapshotToJSONTyped(json, false);
}

export function InvoiceContactInfoSnapshotToJSONTyped(value?: InvoiceContactInfoSnapshot | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'phoneNumber': value['phoneNumber'],
        'homePhone': value['homePhone'],
    };
}

